// src/components/DynamicFontLoader.jsx
import { useEffect } from 'react';
import { getCurrentBranding } from '../config/branding';

const DynamicFontLoader = () => {
    useEffect(() => {
        const branding = getCurrentBranding();

        // Remove existing dynamic fonts
        const existingFonts = document.querySelectorAll('style[data-dynamic-fonts]');
        existingFonts.forEach(style => style.remove());

        // Create new style element for fonts
        const fontStyle = document.createElement('style');
        fontStyle.setAttribute('data-dynamic-fonts', 'true');

        // Generate font-face declarations
        const fontFaces = branding.fontFiles.map(font => `
      @font-face {
        font-family: '${font.family}';
        src: ${font.src};
        font-display: swap;
      }
    `).join('\n');

        // Add global font family
        const globalStyle = `
      * {
        font-family: ${branding.fonts.primary};
        letter-spacing: 0px;
      }
    `;

        fontStyle.textContent = fontFaces + globalStyle;
        document.head.appendChild(fontStyle);

        // Title and favicon are already set at import time in setInitialTitle.js

    }, []);

    return null; // This component doesn't render anything
};

export default DynamicFontLoader;
